export const classes = {
  dialog: 'px-0 py-0 size-[1600px] max-w-[80vw] max-h-[80vh]',
  imgWrapper: 'grow bg-grey-9 size-full place-center',
  img: 'max-w-full max-h-full',
  iframe: 'size-full border-0',
  loading: 'size-full place-center text-grey-6 dark:text-mauve-3 text-sm',
};
